import React, { useCallback } from 'react';
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';
import ellipsisIcon from 'assets/icons/ellipsis-v.svg';
import trashIcon from 'assets/icons/trash.svg';
import './SlideoutItem.scss';

type Props = {
  onDelete?: (e: { name?: string }) => Promise<{ name?: string }>;
  item: {
    name?: string;
  };
};

export const SlideoutItem = ({ onDelete, item }: Props) => {
  const onDeleteCb = useCallback(() => onDelete && onDelete(item), [item]);

  return (
    <UncontrolledDropdown className="slideout-item__wr">
      <DropdownToggle tag="div" data-toggle="dropdown">
        <div className="slideout-item">
          <div className="slideout-item__name">{item.name}</div>
          <div className="slideout-item__ellipsis">
            <img src={ellipsisIcon} alt="menu ellipsis" />
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu right>
        {onDelete && (
          <DropdownItem
            className="slideout-item__dropdown-item"
            onClick={onDeleteCb}
          >
            <div className="slideout-item__dropdown-action">
              <img
                src={trashIcon}
                className="slideout-item__trash-icon"
                alt="delete attribute"
              />
              Delete
            </div>
          </DropdownItem>
        )}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};
